import { Controller } from 'stimulus'

export default class Montage extends Controller {
  static targets = ['layers', 'layer']

  resized() {
    // scaling and adjusting height of the component based on the proportion of the component's width and it's content's width
    const montageScaling = Math.min(1, this.element.offsetWidth / this.layersTarget.offsetWidth)
    this.element.style.transform = `scale(${montageScaling})`
    this.element.style.height =
      window.innerWidth >= 1024
        ? `${this.layersTarget.offsetHeight * montageScaling * 0.8}px`
        : `${this.layersTarget.offsetHeight * montageScaling}px`
    this.scrolled()
  }

  scrolled() {
    const top = this.element.getBoundingClientRect().top

    this.layerTargets.forEach((layerTarget) => {
      layerTarget.style.transform = `rotateY(${top / 80}deg) rotateX(${top / 120}deg) translateZ(${
        layerTarget.dataset.depth || 0
      })`
    })
  }
}
